@if (initialized()) {
  <div class="page py-4">
    <div class="container py-3 mb-auto">
      <div class="row gy-4">
        <div class="col-12">
          <p class="h3">Resultados de búsqueda</p>

          @if (searchTerm()) {
            <p class="h5">
              <span class="fw-bold">“{{ searchTerm() }}”</span>
            </p>
          }
        </div>

        @for (item of data(); track $index) {
          <div class="col-12 px-0">
            <div class="row">
              <div class="col-auto">
                <div class="search-item-image">
                  <img
                    [src]="item.cover | assetFormatter"
                    [alt]="item.meta_title"
                  />
                </div>
              </div>

              <div class="col">
                <div class="search-item-content">
                  <div class="d-flex">
                    @if (item.subject) {
                      <span class="category-badge text-white me-3">
                        {{ item.subject?.name }}
                      </span>
                    }

                    <div>
                      <span class="lato-regular">
                        @if (item.media_type === "video") {
                          <span class="me-2">Video</span>

                          <img
                            src="/img/video_icon_b.webp"
                            height="20"
                            alt="Video"
                          />
                        } @else {
                          <span class="me-2">Artículo</span>

                          <img
                            src="/img/article_icon_b.webp"
                            height="20"
                            alt="Artículo"
                          />
                        }
                      </span>
                    </div>
                  </div>

                  <a
                    class="h5 mb-3"
                    [innerHTML]="item.title"
                    [routerLink]="['/articulo', item.slug]"
                  ></a>

                  @if (item.author) {
                    <a
                      class="author-label h6 mb-2"
                      [routerLink]="['/buscar']"
                      [queryParams]="{ a: item.author?.id }"
                    >
                      Por {{ item.author?.name + " " + item.author?.surname }}
                    </a>
                  }

                  <div [innerHTML]="item.meta_description"></div>
                </div>
              </div>
            </div>
          </div>
        } @empty {
          <div class="col-12 text-center py-4">
            <p class="h5 fw-normal font-monospace mb-0">
              No se encontraron resultados de búsqueda
            </p>
          </div>
        }
      </div>
    </div>

    <div class="container">
      <!-- @if (params.size > params.take) { -->
      <div class="row">
        <div class="col-auto mx-auto text-center">
          <ngb-pagination
            [collectionSize]="params.size"
            [(page)]="page"
            (pageChange)="submit()"
            [maxSize]="isMobile() ? 2 : 12"
          />
        </div>
      </div>
      <!-- } -->
    </div>
  </div>
}
